import React from 'react';
const Section = ({title, subtitle, sectionClass, children, id }) => (
  <div className={sectionClass ? `section ${sectionClass}` : 'section'} id={id}>
    <div className="header">
      <div className="title">
        {title}
      </div>
      <div className="separator"/>
      <div className="subtitle">
        {subtitle}
      </div>
    </div>
    { children }
  </div>
);

export default Section;




// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/snapsell/Section.jsx